// Centralised environment config. CRA exposes only REACT_APP_* vars at build time.
const trimSlash = (s = '') => s.replace(/\/+$/, '');

export const ENV = {
  API_BASE_URL: trimSlash(process.env.REACT_APP_API_BASE_URL || 'https://ucapi.citycraft.in:8443'),
  API_PREFIX: process.env.REACT_APP_API_PREFIX || '/api/v1',
  PG_KEY: process.env.REACT_APP_PG_KEY || '',
};

// Full API root, e.g. https://ucapi.citycraft.in:8443/api/v1
export const API_ROOT = `${ENV.API_BASE_URL}${ENV.API_PREFIX}`;
